var Component = require("!../../../../node_modules/.11.1.4@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/.11.1.4@vue-loader/lib/selector?type=script&index=0!./button-group.vue"),
  /* template */
  require("!!../../../../node_modules/.11.1.4@vue-loader/lib/template-compiler?{\"id\":\"data-v-0afbc731\"}!../../../../node_modules/.11.1.4@vue-loader/lib/selector?type=template&index=0!./button-group.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/packages/button/src/button-group.vue
// module id = 171
// module chunks = 0